<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" style="max-width: 400px">
        <v-card
          v-if="!validAccessKey"
          shaped
          class="elevation-24"
          :style="{ 'border-bottom-right-radius': '0px' }"
        >
          <v-list-item class="pt-6">
            <v-list-item-content>
              <v-img src="@/assets/logo-bni-qris.webp" max-width="8rem"></v-img>

              <h2 class="mt-4 font-weight-black">Lupa Password</h2>
            </v-list-item-content>
          </v-list-item>
          <v-card-title
            v-if="loadingValidate"
            class="d-flex justify-center align-center"
            >Validating . . .</v-card-title
          >
          <v-card-text style="padding-bottom: 4px" v-if="!loadingValidate">
            <div class="grey--text text-justify">
              Untuk melakukan reset password silahkan masukkan Email Anda. Kami
              akan mengirimkan link reset password ke email yang Anda input
            </div>
            <v-form ref="form" lazy-validation v-on:submit.prevent="">
              <v-text-field
                :hint="hint"
                persistent-hint
                label="Email"
                name="email"
                prepend-icon="mdi-email"
                type="text"
                v-model="email"
                v-on:keyup.enter="reset"
                :error-messages="emailErrors"
                @change="$v.email.$touch()"
                @blur="$v.email.$touch()"
              />
            </v-form>
          </v-card-text>
          <v-card-actions
            v-if="!loadingValidate"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 8px 16px 16px 16px;
            "
          >
            <v-btn
              color="orange"
              @click="back"
              :disabled="loading"
              style="color: white"
              >back</v-btn
            >
            <v-btn
              color="#005f7a"
              style="color: white"
              @click="reset"
              :disabled="loading || timer > 1"
              >Send</v-btn
            >
          </v-card-actions>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            bottom
            color="red lighten-2"
          />
        </v-card>

        <v-card
          v-if="validAccessKey"
          shaped
          class="elevation-24"
          :style="{ 'border-bottom-right-radius': '0px' }"
        >
          <v-list-item class="pt-6">
            <v-list-item-content>
              <v-img src="@/assets/logo-bni-qris.webp" max-width="8rem"></v-img>

              <h2 class="mt-4 font-weight-black">Lupa Password</h2>
            </v-list-item-content>
          </v-list-item>
          <v-card-title style="padding-bottom: 0px" v-if="!passChanged"
            >Input Password Baru</v-card-title
          >
          <v-card-text v-if="passChanged"
            >Password berhasil diubah, silahkan klik link berikut untuk login ke
            portal admin. <a @click="back">klik disini</a></v-card-text
          >

          <v-card-text style="padding-bottom: 8px" v-if="!passChanged">
            <div class="grey--text">Silahkan masukkan pasword baru anda.</div>
            <v-form ref="form" lazy-validation>
              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                v-model="password"
                v-on:keyup.enter="changePassword"
                :error-messages="passwordErrors"
                @change="$v.password.$touch()"
                @blur="$v.password.$touch()"
                @input="$v.password.$touch()"
                :append-icon="passwordFieldType ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="() => (passwordFieldType = !passwordFieldType)"
                :type="passwordFieldType ? 'password' : 'text'"
              />
              <v-text-field
                id="passwordConfirmation"
                label="Password Confirmation"
                name="passwordConfirmation"
                prepend-icon="mdi-lock-check"
                v-model="passwordConfirmation"
                v-on:keyup.enter="changePassword"
                :error-messages="passwordConfirmationErrors"
                @change="$v.passwordConfirmation.$touch()"
                @blur="$v.passwordConfirmation.$touch()"
                @input="$v.passwordConfirmation.$touch()"
                :append-icon="
                  passwordConfirmFieldType ? 'mdi-eye-off' : 'mdi-eye'
                "
                @click:append="
                  () => (passwordConfirmFieldType = !passwordConfirmFieldType)
                "
                :type="passwordConfirmFieldType ? 'password' : 'text'"
              />
            </v-form>
          </v-card-text>
          <v-card-actions
            v-if="!passChanged"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 4px 16px 16px 16px;
            "
          >
            <v-btn
              color="orange"
              @click="back"
              :disabled="loading"
              style="color: white"
              >back</v-btn
            >
            <v-btn
              color="#005f7a"
              @click="changePassword"
              :disabled="loading"
              style="color: white"
              >Reset</v-btn
            >
          </v-card-actions>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            bottom
            color="red lighten-2"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { sameAs, email } from 'vuelidate/lib/validators';
import { resendEmail, dataExtraString3 } from '../store/params';
import CustomEncryption from '../lib/CustomEncryption';

export default {
  name: 'ForgotPassword',
  props: {
    source: {
      type: String,
      default: null,
    },
  },
  mixins: [validationMixin],
  validations: {
    email: {
      required(value) {
        if (!this.validAccessKey) {
          return value != '';
        }
        return true;
      },
      email,
    },
    password: {
      required(value) {
        if (this.validAccessKey) {
          return value != '';
        }
        return true;
      },
      minLength(value) {
        if (this.validAccessKey) {
          return value.length >= 12;
        }
        return true;
      },
      upperCase(value) {
        if (this.validAccessKey) {
          const pattern = /[A-Z]/;
          return !!pattern.test(value);
        }
        return true;
      },
      lowerCase(value) {
        if (this.validAccessKey) {
          const pattern = /[a-z]/;
          return !!pattern.test(value);
        }
        return true;
      },
      specialChar(value) {
        if (this.validAccessKey) {
          const pattern = /[!-/:@[-`{-~]/;
          return !!pattern.test(value);
        }
        return true;
      },
      numeric(value) {
        if (this.validAccessKey) {
          const pattern = /\d/;
          return !!pattern.test(value);
        }
        return true;
      },
    },
    passwordConfirmation: {
      required(value) {
        if (this.validAccessKey) {
          return value != '';
        }
        return true;
      },
      sameAsPassword: sameAs('password'),
    },
  },
  beforeCreate() {
    if (this.$store.state.authenticated) {
      this.$router.push({ name: 'Home' });
    }
  },
  mounted() {
    if (this.$route.name == 'ValidateForgotPassword') {
      if (
        this.$route.params.accessKey != '' &&
        this.$route.params.accessKey != null
      ) {
        this.checkAccessKey();
      }
    }
  },
  data() {
    return {
      loadingValidate: false,
      passwordFieldType: true,
      passwordConfirmFieldType: true,
      email: '',
      password: '',
      passwordConfirmation: '',
      validAccessKey: false,
      timer: 0,
      passChanged: false,
      resendEmail,
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push('Email is required');
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push('Password is required');
      if (!this.$v.password.lowerCase) {
        errors.push('Password must have lowercase character');
      }
      if (!this.$v.password.upperCase) {
        errors.push('Password must have uppercase character');
      }
      if (!this.$v.password.numeric) {
        errors.push('Password must have numeric character');
      }
      if (!this.$v.password.specialChar) {
        errors.push('Password must have special character');
      }
      if (!this.$v.password.minLength) {
        errors.push('Password must be at least 12 characters long');
      }
      return errors;
    },
    passwordConfirmationErrors() {
      const errors = [];
      if (!this.$v.passwordConfirmation.$dirty) return errors;
      if (!this.$v.passwordConfirmation.required) {
        errors.push('Password Confirmation is required');
      }
      if (!this.$v.passwordConfirmation.sameAsPassword) {
        errors.push('Passwords must be identical.');
      }
      return errors;
    },
    hint() {
      const second = `0${(this.timer % 60).toString()}`.slice(-2);
      const minute = `0${Math.floor(this.timer / 60).toString()}`.slice(-2);
      return this.timer == 0
        ? ''
        : `Kirim ulang reset email dalam ${minute}:${second}`;
    },
  },

  methods: {
    async reset() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading && this.timer < 1) {
        // eslint-disable-next-line new-cap
        const speEncrypt = new CustomEncryption();
        const extras = speEncrypt.decryption({
          enc: process.env.VUE_APP_STRING_EXTRA2,
          masterkey: dataExtraString3,
        });
        await this.$store
          .dispatch('requestAuthKey', {
            encrypted_request: speEncrypt.encrypt('', this.email, extras),
          })
          .then((response) => {
            speEncrypt.decrypt(response, true, true, extras);
            if (response) {
              this.forgotPassword(speEncrypt, extras);
            }
          });
      }
    },

    async forgotPassword(speEncrypt, extras) {
      this.$store
        .dispatch('forgotPassword', {
          email: this.email,
          encrypted_email: speEncrypt.encrypt(
            speEncrypt.encryption(this.email, true),
            '',
            extras
          ),
          access_key: speEncrypt.encrypt(
            localStorage.getItem('fp_qram_key'),
            '',
            extras
          ),
        })
        .then((responseData) => {
          if (responseData) {
            this.timer = this.resendEmail == null ? 300 : this.resendEmail;
            this.interval = setInterval(() => {
              this.timer -= 1;
              if (this.timer == 0) {
                clearInterval(this.interval);
              }
            }, 1000);
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', false);
        });
    },

    async checkAccessKey() {
      this.loadingValidate = true;
      // eslint-disable-next-line new-cap
      const speEncrypt = new CustomEncryption();
      const extras = speEncrypt.decryption({
        enc: process.env.VUE_APP_STRING_EXTRA2,
        masterkey: dataExtraString3,
      });
      let accessKey = this.$route.params.accessKey.replace('-', '+');
      accessKey = accessKey.replace('_', '/');
      let idEncrypted = this.$route.params.idEncrypted.replace('-', '+');
      idEncrypted = idEncrypted.replace('_', '/');
      const authkey = speEncrypt.decrypt(atob(accessKey), true, true, extras);
      if (!authkey) {
        this.$router.push('/login');
      } else {
        await this.$store
          .dispatch('validateForgotPassword', {
            access_key: speEncrypt.encrypt(authkey, '', extras),
            id: speEncrypt.decrypt(atob(idEncrypted), false, false, extras),
            id_encrypted: speEncrypt.encrypt(
              speEncrypt.decrypt(atob(idEncrypted), false, false, extras),
              '',
              extras
            ),
          })
          .then((res) => {
            if (res) {
              this.validAccessKey = true;
            } else {
              this.$router.push('/login');
            }
          });
      }
      this.loadingValidate = false;
    },

    async changePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        let idEncrypted = this.$route.params.idEncrypted.replace('-', '+');
        idEncrypted = idEncrypted.replace('_', '/');
        // eslint-disable-next-line new-cap
        const speEncrypt = new CustomEncryption();
        let accessKey = this.$route.params.accessKey.replace('-', '+');
        accessKey = accessKey.replace('_', '/');
        const extras = speEncrypt.decryption({
          enc: process.env.VUE_APP_STRING_EXTRA2,
          masterkey: dataExtraString3,
        });
        const authkey = speEncrypt.decrypt(
          atob(accessKey),
          false,
          false,
          extras
        );
        this.$store
          .dispatch('changePassword', {
            password: this.password,
            passwordConfirmation: this.passwordConfirmation,
            encryptedPassword: speEncrypt.encrypt(
              speEncrypt.encryption(this.password, true),
              '',
              extras
            ),
            encryptedPasswordConfirmation: speEncrypt.encrypt(
              speEncrypt.encryption(this.passwordConfirmation, true),
              '',
              extras
            ),
            accessKey: speEncrypt.encrypt(authkey, '', extras),
            id: speEncrypt.decrypt(atob(idEncrypted), false, false, extras),
            idEncrypted: speEncrypt.encrypt(
              speEncrypt.decrypt(atob(idEncrypted), false, false, extras),
              '',
              extras
            ),
          })
          .then((res) => {
            if (res) {
              this.passChanged = true;
              localStorage.removeItem('fp_qram_key');
            }
          });
      }
    },

    back() {
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.border-top {
  border-radius: 24px 0px 0px 0px;
}
.header-logo {
  align-self: flex-start;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
